import React, { FC } from 'react';
import { TProductSeriesDetailOverviewSolutionProps } from '../@shared/solutions/types/solutions.types';
import { TProductSeriesDetailOverviewSolutionModel } from './models/productSeriesDetailOverviewSolutionModel.model';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import useExperienceEditorPlaceholder from '../../hooks/useExperienceEditorPlaceholder';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import Solutions from '../@shared/solutions';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { titleKeyModelSolutions, titleKeySeriesSolutions } from '../../constants/dictionary.constants';

const ProductSeriesDetailOverviewSolution: FC<TProductSeriesDetailOverviewSolutionProps> = (props) => {
  const model = new TProductSeriesDetailOverviewSolutionModel(props);
  const isFieldsEmpty = props?.fields && Object.keys(props?.fields).length === 0;
  const apiResponse = !isFieldsEmpty && isEmptyResponse(props);
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);
  const isInnerComponentsEmpty = model?.innerComponents.length === 0;

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return <ExperienceEditorComponentPlaceholder image={model.thumbnailEE} componentName={model.componentName} />;
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={model.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  if (isFieldsEmpty || isInnerComponentsEmpty) {
    return null;
  }

  const getDictionaryKey = (seriesSolutionsKey, modelSolutionsKey) => {
    if (props?.isModelSolutions) {
      return modelSolutionsKey;
    }
    return seriesSolutionsKey;
  };

  return (
    <Solutions
      title={model?.title}
      fields={model?.innerComponents}
      titleDictionaryKey={getDictionaryKey(titleKeySeriesSolutions, titleKeyModelSolutions)}
    />
  );
};

export default ProductSeriesDetailOverviewSolution;
